import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableTruncate from '@/components/datatable/DataTableTruncate.vue';
import RolesTableActions from '@/components/roles/RolesTableActions.vue';
import type { Company, Role, RolePermission } from '@/types';
import type { CellContext, ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Role>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'roles.table.name',
            }),
    },
    {
        accessorKey: 'display_name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'roles.table.display_name',
            }),
    },
    {
        accessorKey: 'description',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'roles.table.description',
            }),
    },
    {
        accessorKey: 'is_client_text',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'roles.table.is_client_text',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        id: 'permissions_text',
        accessorFn: (row) =>
            row.permissions.map((permission: RolePermission) => permission.display_name).join(', '),
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'roles.table.permissions_text',
            }),
        cell: (ctx: CellContext<Role, any>) => {
            return h(DataTableTruncate, {
                value: ctx.getValue(),
                size: 'sm',
            });
        },
    },
    {
        id: 'companies_text',
        accessorFn: (row) => row.company.map((company: Company) => company.name).join(', '),
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'roles.table.companies_text',
            }),
        cell: (ctx: CellContext<Role, any>) => {
            return h(DataTableTruncate, {
                value: ctx.getValue(),
                size: 'sm',
            });
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(RolesTableActions, {
                role: row.original,
            });
        },
    },
];
